import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createSlots as _createSlots } from "vue"

import { ref, computed, getCurrentInstance } from 'vue'
import { getCityListApi } from '@/apis/others'
import { CityM } from '@/models/others'


export default /*@__PURE__*/_defineComponent({
  __name: 'SelectCity',
  props: {
    classNames: {   // 类名
        type: Array,
        default: () => []
    },
    filterable: {   // 是否可筛选
        type: Boolean,
        default: true
    },
    clearable: {    // 是否可一键清除
        type: Boolean,
        default: true
    },
    multiple: {     // 是否可多选
        type: Boolean,
        default: false
    },
    showSelectAll: { // 是否显示全选选项
        type: Boolean,
        default: false
    },
    collapseTags: { // 是否折叠 tags
        type: Boolean,
        default: false
    },
    maxCollapseTags: { // 折叠后显示的 tag 数量
        type: Number,
        default: 1
    }
},
  emits: ['selectedChange'],
  setup(__props, { expose: __expose, emit: __emit }) {

const proxy = getCurrentInstance() as any
const emits = __emit
const props = __props

const selectedId = ref<any>([])
const list = ref<CityM[]>([])
const onGetList = async () => {
    const {code, data, msg} = await getCityListApi() as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
    list.value = data
}
onGetList()

// 全选城市的 ID 列表
const allCityIds = computed(() => list.value.map(item => item.id))

// 是否全选（当所有城市都被选中时）
const isAllChecked = computed({
    get: () => {
        if (!props.multiple || selectedId.value.length === 0) return false
        return allCityIds.value.every(id => selectedId.value.includes(id))
    },
    set: (val: boolean) => {
        if (val) {
            selectedId.value = [...allCityIds.value]
        } else {
            selectedId.value = []
        }
        emits('selectedChange', selectedId.value)
    }
})

const onSelectAllChange = (val: boolean) => {
    if (val) {
        selectedId.value = [...allCityIds.value]
    } else {
        selectedId.value = []
    }
    emits('selectedChange', selectedId.value)
}

const onSelectedChange = (val) => {
    selectedId.value = val
    emits('selectedChange', selectedId.value)
}

// 暴露方法给父组件使用
__expose({
    getSelectedIds: () => selectedId.value,
    getAllIds: () => allCityIds.value,
    isAllChecked: () => isAllChecked.value,
    setSelectedIds: (ids: any) => {
        selectedId.value = ids
        emits('selectedChange', selectedId.value)
    },
    selectAll: () => {
        if (props.multiple) {
            selectedId.value = [...allCityIds.value]
            emits('selectedChange', selectedId.value)
        }
    },
    clearSelection: () => {
        selectedId.value = []
        emits('selectedChange', selectedId.value)
    }
})

return (_ctx: any,_cache: any) => {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createBlock(_component_el_select, {
    class: _normalizeClass(__props.classNames),
    modelValue: selectedId.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedId).value = $event)),
    filterable: __props.filterable,
    clearable: __props.clearable,
    multiple: __props.multiple,
    "collapse-tags": __props.collapseTags,
    "max-collapse-tags": __props.maxCollapseTags,
    placeholder: "请选择城市",
    onChange: onSelectedChange
  }, _createSlots({
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item) => {
        return (_openBlock(), _createBlock(_component_el_option, {
          key: item.id,
          label: item.name,
          value: item.id
        }, null, 8, ["label", "value"]))
      }), 128))
    ]),
    _: 2
  }, [
    (__props.showSelectAll && __props.multiple)
      ? {
          name: "header",
          fn: _withCtx(() => [
            _createVNode(_component_el_checkbox, {
              modelValue: isAllChecked.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isAllChecked).value = $event)),
              onChange: onSelectAllChange
            }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createTextVNode("全选")
              ])),
              _: 1
            }, 8, ["modelValue"])
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["class", "modelValue", "filterable", "clearable", "multiple", "collapse-tags", "max-collapse-tags"]))
}
}

})